export const IconHeart = () => {
    return (
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.09188 8.13445L10 17L17.9081 8.13445C19.364 6.50234 19.364 3.85618 17.9081 2.22408C16.4523 0.591975 14.0919 0.591975 12.636 2.22408L10 5.17926L7.36396 2.22408C5.90812 0.591974 3.54773 0.591974 2.09188 2.22408C0.636039 3.85618 0.636039 6.50234 2.09188 8.13445Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
